import { Checkbox, FormControlLabel, FormGroup, Tooltip } from "@mui/material";
import "./ReceivingETExpandable.scss";
import { useEffect, useState } from "react";
import Input from "../../../../../../components/Inputs/Input";
import BasicDatePicker from "../../../../../../components/Datepicker/Datepicker";

import MultioptionButton from "../../../../../../components/Buttons/MultioptionButton";

export const ReceivingETExpandable = ({ data, hasSN = false }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [editET, setEditEt] = useState(false);
  const [form, setForm] = useState({
    version: null,
    id: null,
    engineeringTask: null,
    thresholdHours: null,
    thresholdCycles: null,
    thresholdDays: null,
    thresholdTotalHours: null,
    thresholdTotalCycles: null,
    thresholdTotalDays: null,
    thresholdScheduleDate: null,
    intervalHours: null,
    intervalCycles: null,
    intervalDays: null,
    intervalScheduleDate: null,
    part: null,
    accountFleet: null,
    thresholdLatest: false,
    intervalLatest: false,
    overrideValue: false,
    companyId: null,
    maxRepetitions: null,
    useFlightDays: false,

    description: null,
    completedNumbers: null,
    scheduleDate: null,
    effectiveDate: null,
    latest: null,

    hours: null,
    cycles: null,
    days: null,
  });

  // functions

  const multiOptionsBtn = [
    { label: "Save", icon: "icon-save", id: "save" },
    { label: "Save And Continue", icon: "icon-save", id: "save-and-continue" },
    { label: "Cancel", icon: "icon-cross", id: "cancel", type: "danger" },
  ];

  const buttonsCallback = {
    save: () => {},
    "save-continue": () => {},
    cancel: () => {
      setEditEt(false);
    },
  };

  useEffect(() => {
    setForm(data);
  }, []);

  return (
    <section className={`receiving-et-expandable`}>
      <div
        className={`receiving-et-expandable-header ${
          isOpen ? "item-open-header item-sticky-header" : ""
        }`}
        style={{
          background: !isOpen ? "var(--white)" : "",
          border: !isOpen ? "var(--border)" : "",
        }}
        onClick={() => {
          setIsOpen(!isOpen);
        }}
      >
        <p
          className="ellipsis"
          style={{
            color: form?.engineeringTask
              ? "var(--blue-300)"
              : "var(--black-mid)",
            textDecoration: form?.engineeringTask ? "underline" : "",
          }}
        >
          {form?.engineeringTask?.etNumber || "--"}
        </p>
        <p className="ellipsis">{form.description || "--"}</p>
        <Checkbox
          checked={form.useFlightDays}
          onClick={(e) => {
            e.stopPropagation();
            setForm((prev) => {
              return { ...prev, useFlightDays: e.target.checked };
            });
          }}
        ></Checkbox>
        <p className="ellipsis">{form.maxRepetitions || "--"}</p>
        <p className="ellipsis">{form.completedNumbers || "--"}</p>
      </div>
      {isOpen && (
        <div className="receiving-et-expandable-content">
          <div>
            <h3>General Information</h3>
            {editET ? (
              <MultioptionButton
                buttons={multiOptionsBtn}
                buttonCallbacks={buttonsCallback}
              ></MultioptionButton>
            ) : (
              <Tooltip
                title={
                  !hasSN
                    ? "ETs cannot be edited if the part does not have a Serial Number (SN). Please assign an SN to the selected NLA part."
                    : ""
                }
                arrow
              >
                <button
                  disabled={hasSN ? false : true}
                  onClick={() => setEditEt(!editET)}
                  className="btn-receiving-edit-et"
                >
                  <i className="icon-edit"></i> Edit
                </button>
              </Tooltip>
            )}
          </div>
          <div className="receiving-et-expandable-content-schedule">
            {/* <div>
              <p>Schedule Date</p> */}
            {/* <Input
                style={{
                  width: "7rem",
                }}
              ></Input> */}

            {/* </div> */}
            <div>
              <div
                className={`receiving-et-expandable-check-cont ${
                  form.latest ? "container-check-checked" : ""
                }`}
              >
                <FormGroup>
                  <FormControlLabel
                    disabled={!editET}
                    control={
                      <Checkbox
                        onChange={(e) => {
                          setForm((prev) => {
                            return { ...prev, latest: e.target.checked };
                          });
                        }}
                        checked={form.latest}
                      />
                    }
                    label={
                      <p
                        style={{
                          color: "var(--black-mid)",
                          fontSize: "calc(var(--p-size) + .1rem)",
                        }}
                      >
                        Latest
                      </p>
                    }
                  />
                </FormGroup>
              </div>

              <div
                className={`receiving-et-expandable-check-cont ${
                  form.useFlightDays ? "container-check-checked" : ""
                }`}
              >
                <FormGroup>
                  <FormControlLabel
                    disabled={!editET}
                    control={
                      <Checkbox
                        onClick={(e) => {
                          setForm((prev) => {
                            return { ...prev, useFlightDays: e.target.checked };
                          });
                        }}
                        checked={form.useFlightDays}
                      />
                    }
                    label={
                      <p
                        style={{
                          color: "var(--black-mid)",
                          fontSize: "calc(var(--p-size) + .1rem)",
                        }}
                      >
                        Use Flight Days
                      </p>
                    }
                  />
                </FormGroup>
              </div>
            </div>
          </div>
          <div className="receiving-et-expandable-content-treshold-labels">
            <p>Hours</p>
            <p>Cycles</p>
            <p>Days</p>
            <p>Total Hours</p>
            <p>Total Cycles</p>
            <p>Total Days</p>
            <p>Schedule Date</p>
          </div>
          <div
            className="receiving-et-expandable-content-treshold-cont item-open-header"
            style={{
              justifyContent: "space-between",
            }}
          >
            <p
              style={{
                fontWeight: "600",
                width: "8%",
              }}
            >
              Treshold
            </p>
            {!editET ? (
              <p style={{ width: "10%" }}>{form.thresholdHours || "--"}</p>
            ) : (
              <Input
                style={{ width: "10%" }}
                value={form.thresholdHours}
              ></Input>
            )}
            {!editET ? (
              <p style={{ width: "10%" }}>{form.thresholdCycles || "--"}</p>
            ) : (
              <Input
                style={{ width: "10%" }}
                value={form.thresholdCycles}
              ></Input>
            )}
            {!editET ? (
              <p style={{ width: "9%" }}>{form.thresholdDays || "--"}</p>
            ) : (
              <Input
                style={{ width: "10%" }}
                value={form.thresholdDays}
              ></Input>
            )}
            {!editET ? (
              <p style={{ width: "11%" }}>{form.thresholdTotalHours || "--"}</p>
            ) : (
              <Input
                style={{ width: "10%" }}
                value={form.thresholdTotalHours}
              ></Input>
            )}
            {!editET ? (
              <p style={{ width: "15%" }}>
                {form.thresholdTotalCycles || "--"}
              </p>
            ) : (
              <Input
                style={{ width: "10%" }}
                value={form.thresholdTotalCycles}
              ></Input>
            )}
            {!editET ? (
              <p style={{ width: "15%" }}>{form.thresholdTotalDays || "--"}</p>
            ) : (
              <Input
                style={{ width: "10%" }}
                value={form.thresholdTotalDays}
              ></Input>
            )}
            {!editET ? (
              <p style={{ width: "8rem" }}>
                {form.thresholdScheduleDate || "--"}
              </p>
            ) : (
              <BasicDatePicker
                disabled={!editET}
                style={{
                  width: "8rem",
                }}
                value={form.thresholdScheduleDate}
              ></BasicDatePicker>
            )}
          </div>
          <div
            className="receiving-et-expandable-content-intervals-cont"
            style={{
              justifyContent: "space-between",
            }}
          >
            <p
              style={{
                width: "8%",
              }}
            >
              Interval
            </p>
            {!editET ? (
              <p
                style={{
                  width: "10%",
                }}
              >
                {form.intervalHours || "--"}
              </p>
            ) : (
              <Input
                style={{ width: "10%" }}
                value={form.intervalHours}
              ></Input>
            )}
            {!editET ? (
              <p
                style={{
                  width: "10%",
                }}
              >
                {form.intervalCycles || "--"}
              </p>
            ) : (
              <Input
                style={{ width: "10%" }}
                value={form.intervalCycles}
              ></Input>
            )}
            {!editET ? (
              <p
                style={{
                  width: "9%",
                }}
              >
                {form.intervalDays || "--"}
              </p>
            ) : (
              <Input style={{ width: "9%" }} value={form.intervalDays}></Input>
            )}
            <p
              style={{
                width: "9%",
              }}
            >
              --
            </p>
            <p
              style={{
                width: "10%",
              }}
            >
              --
            </p>
            <p
              style={{
                width: "10%",
              }}
            >
              --
            </p>
            {!editET ? <p style={
              {
                width : "8rem"
              }
            }>{form.intervalScheduleDate || "--"}</p> : <BasicDatePicker
              disabled={!editET}
              style={{
                width: "8rem",
              }}
              value={form.intervalScheduleDate}
            ></BasicDatePicker> }
          </div>
          <div className="receiving-et-expandable-content-effective-date-cont">
            <div>
              <p>Effective Date</p>
              {/* <Input
                style={{
                  width: "7rem",
                }}
              ></Input> */}
              <BasicDatePicker
                disabled={!editET}
                style={{
                  width: "7rem",
                }}
                value={form.effectiveDate}
              ></BasicDatePicker>
            </div>
            <div>
              <p>Actuals</p>
              <span>
                <i className="icon-success"></i> Hours, Cycles, and Days as of
                Effective
              </span>
            </div>
          </div>
          <div className="receiving-et-expandable-content-completed-numb-cont">
            <div
              style={{
                width: "40%",
              }}
            >
              <p
                style={{
                  fontWeight: "600",
                  color: "var(--black-mid)",
                }}
              >
                Completed Number
              </p>
              <Input
                disabled={!editET}
                style={{
                  width: "6rem",
                }}
                value={form.completedNumbers}
                onChange={(e) => {
                  setForm((prev) => {
                    return { ...prev, completedNumbers: e.target.value };
                  });
                }}
                isNumeric
              ></Input>
            </div>
            <div
              style={{
                width: "60%",
              }}
            >
              <p>Hours</p>
              <Input
                disabled={!editET}
                style={{
                  // width: "5rem",
                  flexGrow: "1",
                }}
                isNumeric
                value={form.hours}
                onChange={(e) => {
                  setForm((prev) => {
                    return { ...prev, hours: e.target.value };
                  });
                }}
              ></Input>
              <p>Cycles</p>
              <Input
                disabled={!editET}
                style={{
                  // width: "5rem",
                  flexGrow: "1",
                }}
                onChange={(e) => {
                  setForm((prev) => {
                    return { ...prev, cycles: e.target.value };
                  });
                }}
                value={form.cycles}
                isNumeric
              ></Input>
              <p>Days</p>
              <Input
                onChange={(e) => {
                  setForm((prev) => {
                    return { ...prev, days: e.target.value };
                  });
                }}
                value={form.days}
                isNumeric
                disabled={!editET}
                style={{
                  // width: "5rem",
                  flexGrow: "1",
                }}
              ></Input>
            </div>
          </div>
        </div>
      )}
    </section>
  );
};
